import { Injectable } from '@angular/core';

import { CommonRequestService, PagingParam, SuccessResponse } from './common-request.service';
import { AppSettings } from 'app/app.settings';
import { UserService } from './user.service';
import { SchemaDefinedByKey } from './main-data.service';

@Injectable()
export class DownloadService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }
	
	download(query: string, mapping?: string) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/azgivDownload';
			const params: any = {
				query: query
			};
			if (mapping) { params.mapping = mapping; }
			this.requestService.requestGet(url, {
				params: params
			}, rsp => resolve(rsp.data), err => reject(err));
		});
	}
	// downloadArcgis(query: string) {
	// 	return new Promise((resolve, reject) => {
	// 		const url = AppSettings.serviceRootUrl + 'azgiv/azgivDownloadArcgis';
	// 		const options = new RequestOptions({
	// 			params: {
	// 				query: query
	// 			}
	// 		})
	// 		this.requestService.requestGet(url, options, rsp => resolve(rsp.data), err => reject(err));
	// 	});
	// }
	// download(query: string, mapping: string) {
	// 	return new Promise((resolve, reject) => {
	// 		const url = AppSettings.serviceRootUrl + 'azgiv/azgivDownload';
	// 		const body = {
	// 				query: query,
	// 				mapping: mapping
	// 		};
	// 		const headers = new Headers();
	// 		headers.set('Access-Control-Allow-Origin', '*');
	// 		this.requestService.requestPost(url, body, rsp => resolve(rsp.data), err => reject(err), null, {
	// 			headers: headers
	// 		});
	// 	});
	// }

	// This service is used to download the submitted data
	// With @Param email: The download link will also be sent to that email address for other people to download
	// If @Param email is provided, @Param agency must also be provided
	fileGet(layers: {layerId: number; schema: SchemaDefinedByKey}[], cusShortName: string, email?: string, agency?: string) {
		return new Promise<any>((resolve, reject) => {
			// schema = schema || 'STATE';
			const url = AppSettings.serviceRootUrl + 'azgiv/file';
			const params: any = {
				layers: JSON.stringify(layers),
				filename: ('Layers_' + cusShortName).replace(/ /g, "_")
				// schema: schema
			};
			if (email) {
				params.email = email;
				params.agency = agency;
			}
			// Add stateCode param
			const stateCode = this.userService.getSelectedCustomerInfo('stateCode');
			params.stateCode = stateCode;
			this.requestService.requestGet(url, {
				params: params
			}, rsp => resolve(rsp.data), err => reject(err));
		});
	}

}
